module.exports = __webpack_public_path__ + "img/MAOT_DB_Management_System_snb.047cbbbf.svg";